export default import.meta.ROLLUP_FILE_URL_tERhRUnp0YM2khfmvV9TPw